import React, {Component} from 'react';
import {disposeOnUnmount, inject, observer} from 'mobx-react';
import {withRouter} from "react-router-dom";
import {Spin} from "antd";

import api from "../../../../services/api";
import AirModal from "../../../../common/components/AirModal";
import Review from "./Review";
import PaymentPage from "../../PaymentPage/PaymentPage";
import Success from "./Success";

import "./CheckoutPopup.css"
import {reaction} from "mobx";

@withRouter
@inject('commonStore', 'connectionRequestsStore')
@observer
export default class CheckoutPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingProducts: true,
      customerDetails: null,
      products: [],
      page: 'review'
    }
  }
   componentDidMount() {
     disposeOnUnmount(
       this,
       reaction(
         () => this.props.commonStore.dealer,
         (dealer, reaction) => {
           if (dealer) {
             Promise.all([
               api('getConnectionRequestProducts'),
               api('getConnectionRequestFleetCustomerDetails', dealer.masterApiUserUuid),
               api('getConnectionRequestDiscountProducts')
             ])
               .then(([products, customerDetails, discountProducts]) => {

                 let discountAmount;
                 if (customerDetails.zuora_discount_rate_plan_id) {
                   const discountRatePlan = discountProducts.find(discountRatePlan => discountRatePlan.id === customerDetails.zuora_discount_rate_plan_id);

                   if (discountRatePlan) {
                     const discountPercentage = discountRatePlan && discountRatePlan.productRatePlanCharges && discountRatePlan.productRatePlanCharges[0]
                       && discountRatePlan.productRatePlanCharges[0].pricing && discountRatePlan.productRatePlanCharges[0].pricing[0].discountPercentage;

                     if (discountPercentage) {
                       discountAmount = {
                         amount: discountPercentage,
                         isPercentage: true
                       }
                     } else {

                       const fixedAmount = discountRatePlan && discountRatePlan.productRatePlanCharges && discountRatePlan.productRatePlanCharges[0]
                         && discountRatePlan.productRatePlanCharges[0].pricing && discountRatePlan.productRatePlanCharges[0].pricing[0].discountAmount;

                       if (fixedAmount) {
                         discountAmount = {
                           amount: fixedAmount,
                           isPercentage: false
                         }
                       }
                     }
                   }
                 }

                 const duration = (customerDetails.subscriptionTypes && customerDetails.subscriptionTypes[0] && customerDetails.subscriptionTypes[0].duration) || 24;
                 this.setState({products, customerDetails, duration, loadingProducts: false, discountAmount});
               })
             reaction.dispose()
           }
         },
         { fireImmediately: true }
       )
     );

  }

  getConnectionsToDisplayInReview = () => {
    const portabilityProduct = this.state.products.find(el => el.category === 'portability' &&  el.availability === 'fleet-customer');

    return this.props.connectionRequestsStore.connectionRequests.map(connection => {
      const connectionProperties = {...connection};

      if (connection.portability_reference_contract_uuid) {

        connectionProperties.product = portabilityProduct;
      }

      return {
        ...connectionProperties,
        zuora_product: this.state.products.find(prod => prod.id === connectionProperties.product.zuora_product_id)
      };
    })
      .map(connection => ({
        ...connection,
        rate_plan: connection.zuora_product.productRatePlans
          .find(rateplan => rateplan.duration__c == (connection.portability_reference_contract_uuid? 24: this.state.duration) && connection.subscriptionType.name === rateplan.ChargeModel__c)
      }))
      .filter(function(connection, pos, self) {

        //showing only one portability for vehicle
        return !connection.portability_reference_contract_uuid || self.findIndex(el => el.vehicle.uuid === connection.vehicle.uuid) === pos;
      });
  }

  getConnections = () => {
    return this.props.connectionRequestsStore.connectionRequests.map(connection => ({
      ...connection,
      zuora_product: this.state.products.find(prod => prod.id===connection.product.zuora_product_id)
    }))
      .map(connection => ({
        ...connection,
        rate_plan: connection.zuora_product.productRatePlans
          .find(rateplan => rateplan.duration__c == (connection.portability_reference_contract_uuid? 24: this.state.duration) && connection.subscriptionType.name === rateplan.ChargeModel__c)
      }))
  }

  onConfirmReview = async () => {
    if(this.state.customerDetails.company_type === "small-business") {
      this.setState({page: 'payment'})
    } else {
      await this.props.connectionRequestsStore.subscribeToProducts(this.state.customerDetails.uuid, this.getConnections());
      this.setState({page: 'success'})
    }
  }

  renderContent = () => {
    if(this.state.page === 'review')
      return <Review onNext={this.onConfirmReview} onCancel={this.props.onCancel} discountAmount={this.state.discountAmount} connections={this.getConnectionsToDisplayInReview()} />
    if(this.state.page === 'payment')
      return <PaymentPage connections={this.getConnections()} customerDetails={this.state.customerDetails} onNext={() => this.setState({page: 'success'})} />
    if(this.state.page === 'success')
      return <Success onNext={() => this.props.history.push('/vehicles-manager')} onCancel={() => {
        this.setState({page: 'review'});
        this.props.onCancel();
      }} />
  }

  handleCancel = () => {
    this.setState({page: 'review'}, () => this.props.onCancel())
  }

  render() {
    return (
      <AirModal
        className='CheckoutPopup'
        visible={this.props.hasOwnProperty('visible') ? this.props.visible : true}
        onCancel={this.handleCancel}
        buttonsStyle={{ display: 'none' }}
        width={900}
      >
        <Spin spinning={this.state.loadingProducts}>
          {!this.state.loadingProducts && this.props.visible && this.renderContent()}
        </Spin>
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/CheckoutPopup/CheckoutPopup.js